import { Palette, ThemeConfiguration } from 'mm-theme-configuration/dist/interfaces';
import { Image } from '../template/template.state.types';

interface AdSlotsConfigurationByPlatform {
    [adUnitKey: string]: {
        adUnitPath: string;
        sizes: Array<number> | Array<Array<number>>;
    };
}
interface AdSlotsConfiguration {
    desktop: AdSlotsConfigurationByPlatform;
    mobile: AdSlotsConfigurationByPlatform;
}

interface AdSlotsUnits {
    [adUnitKey: string]: string;
}

export type AdSlots = {
    conf: AdSlotsConfiguration;
    units: AdSlotsUnits;
};

interface Theme {
    palette: Palette;
    themeConfiguration: ThemeConfiguration;
}

interface ExternalScript {
    async: true | false;
    name: string;
    source: string;
    type: string;
}
export type ExternalScripts = Array<ExternalScript>;

export interface ConfigState {
    image: Image | null;
    externalScripts: ExternalScripts;
    facebookAppId: string | null;
    facebookPageId: string | null;
    siteName: string;
    canonicalURL: string;
    favicon: string;
    language: string;
    twitterAccount: string | null;
    template: string;
    logoUrl: string;
    theme: Theme;
    adSlots: AdSlots;
    headerBidderPublisherID: string;
    imagesCDNHost: string;
    ampURL: string | null;
    prevCanonicalUrl: string | null;
    dfpProperty: string;
    pagePath: string;
    propertyEndpoint: string;
    pageType: string;
    timeZone: string;
    locale: string;
    midnightInTimeZone: string;
    editionEndpoint: string;
    edition: string;
}

export const configReducer = (state: ConfigState = {} as ConfigState, action: {type: string}) => {
    switch (action.type) {
    default:
      return state;
  }
};
